import { classes } from 'html-classes';

import { CompanyName } from '~/company/interface';

import styles from './ProductsCarouselSliderOneBlock.module.scss';

export const carouselProps: Record<CompanyName, any> = {
  [CompanyName.CityDrinks]: {
    sliderClassName: styles.sliderClassName,
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    scrollAuto: true,
    leftArrowClassName: classes([styles.carouselIcon]),
    rightArrowClassName: classes([styles.carouselIcon]),
    freeMode: true,
  },
  [CompanyName.Localee]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Okie]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Oskuhus]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Heimkaup]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.CircleK]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Vilo]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Jiffy]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Kids]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
  [CompanyName.Cerise]: {
    slideClassName: styles.product,
    skeletonClassName: styles.productSkeleton,
    spaceBetween: 0,
    sliderClassName: styles.sliderClassName,
    scrollAuto: true,
    leftArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowLeft,
      styles.carouselIcon,
    ]),
    rightArrowClassName: classes([
      styles.controlArrow,
      styles.controlArrowRight,
      styles.carouselIcon,
    ]),
    freeMode: true,
  },
};
